/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   22 Aug 22 2022 00:00:00 PM
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import { routes } from 'src/routes';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import Notification from 'src/components/containers/dashboard/notifications/notification';

type Props = {
  subscription: Object
};

type ComposedProps = Props & WithI18nProps;

const renderRegularPlanExpiredSoon: React.FC<ComposedProps> = (subscription, i18n) => {
  const { dayLeft } = subscription;

  // Uppercase first character (fix for german text, since duration appears at the beginning of string)
  let duration = i18n.translate(`AdminHTML.Common.Duration.dayV3`, {
    count: dayLeft,
    nt_number: i18n.formatNumber(dayLeft)
  });

  const content = `<div>
      <p>
        ${i18n.translate('AdminHTML.Common.RegularPlanExpiredSoonNotification.content_1', {
          t1: `<strong>${duration}</strong>`
        })}
      </p>
      <p>
        ${i18n.translate(
          'AdminHTML.Common.RegularPlanExpiredSoonNotification.preventInterruptions',
          {
            t1: `<strong>${i18n.translate('AdminHTML.Common.Subscription.subscribe')}</strong>`
          }
        )}
      </p>
    </div>`;

  const notification = {
    type: 'warning',
    allowDismiss: false,
    title: i18n.translate('AdminHTML.Common.RegularPlanExpiredSoonNotification.title'),
    content,
    actionLabel: i18n.translate('AdminHTML.Common.Action.subscribeNow'),
    action: routes.subscription.plan()
  };

  return (
    <div className="exceededPlanNotification">
      <Notification status={notification.type} notification={notification} />
    </div>
  );
};

const RegularPlanExpiredModal: React.FC<ComposedProps> = ({ subscription, i18n }) => {
  const { status } = subscription;

  return status === 'regularExpiredSoon' ? renderRegularPlanExpiredSoon(subscription, i18n) : '';
};

const mapStateToProps = state => ({
  subscription: _.get(state.oauth, 'subscription', {})
});

export default connect(mapStateToProps)(withI18n()(RegularPlanExpiredModal));
